import { JSX } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import "./Styles.scss";
import { SerendieSymbol } from "@serendie/symbols";

export class SymbolButton extends BaseComponent<ISymbolButtonProps, ISymbolButtonState>
{
    private handleClick(e: React.MouseEvent<SVGSVGElement, MouseEvent>): void
    {
        if (this.props.disabled)
        {
            return;
        }
        this.props.onClick?.(e);
    }

    public render(): JSX.Element
    {
        const classNames: string[] = [];
        classNames.push(this.props.className ?? '');
        classNames.push('serendie-symbol-button');
        classNames.push(this.props.disabled ? 'serendie-symbol-button--disabled' : '');

        return <SerendieSymbol
            {...this.props}
            className={classNames.join(' ')}
            onClick={e => this.handleClick(e)}
        />
    }
}

export interface ISymbolButtonProps extends React.ComponentProps<typeof SerendieSymbol>
{
    disabled?: boolean;
}

export interface ISymbolButtonState { }
